import React from 'react';
import {
    Page,
    Card,
    Stack,
    Layout,
    Heading,
    TextStyle,
    Banner,
    Button,
    Tag,
    Checkbox,
    TextField,
} from '@shopify/polaris';
import { useState } from 'react';
import { useHistory } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { RuleDefinitions, getRuleDefinitionByType } from '../../rules/TagRuleDefinitions';

function filterRules(ruleDefinitions, searchTerm, selectedTags) {

    var selected = Object.getOwnPropertyNames(selectedTags).filter(_ => {
        return selectedTags[_] === true;
    });

    var filtered = ruleDefinitions;

    selected.forEach(_ => {
        filtered = filtered.filter(__ => __.tags.indexOf(_) > -1);
    });

    if (searchTerm != null) {
        var words = searchTerm.split(" ");

        filtered = filtered.filter(_ => words.filter(__ => _.title.indexOf(__) > -1 || _.description.indexOf(__) > -1).length > 0);
    }

    return filtered;
}

function TagRulesNewPage() {

    const history = useHistory();
    const [searchTerm, setSearchTerm] = useState(null);
    const [selectedTags, setSelectedTags] = useState({
        "Products": false,
        "Variants": false,
        "Customers": false,
        "Orders": false,
        "Tags": false,
        "Metafields": false,
    });

    const filteredRules = filterRules(RuleDefinitions, searchTerm, selectedTags);
    const ruleElementsLeft = filteredRules.filter((v, index) => index % 2 === 0).map(_ => renderRule(_));
    const ruleElementsRight = filteredRules.filter((v, index) => index % 2 !== 0).map(_ => renderRule(_));

    return (
        <div>
            <Helmet>
                <title>Tag Genie - Add Tag Rule</title>
            </Helmet>
            <Page title="List of Tag Rules"
                breadcrumbs={[{ content: 'Tag Rules', url: '/tag-rules' }]}>
                <Layout>
                    <Layout.Section>
                        <Banner
                            title="Missing a rule you need?"
                            action={{ content: 'Chat with us', onAction: requestRule }}
                            status="info"
                        >
                            <p>If you need a rule that seems to be missing, chat with us so that we can implement it.</p>
                        </Banner>
                    </Layout.Section>
                    <Layout.Section>
                        <Stack>
                            <Stack.Item fill>
                                <TextField value={searchTerm}
                                    placeholder="Search for rules to quickly find what you are looking for"
                                    onChange={_ => setSearchTerm(_)}
                                />
                            </Stack.Item>
                            <Stack.Item>
                                <Button onClick={_ => setSearchTerm(null)}>Clear</Button>
                            </Stack.Item>
                        </Stack>
                        <Stack>
                            <Checkbox
                                label="Products"
                                checked={selectedTags["Products"]}
                                onChange={_ => setSelectedTags({
                                    ...selectedTags,
                                    "Products": _
                                })} />
                            <Checkbox
                                label="Variants"
                                checked={selectedTags["Variants"]}
                                onChange={_ => setSelectedTags({
                                    ...selectedTags,
                                    "Variants": _
                                })} />
                            <Checkbox
                                label="Customers"
                                checked={selectedTags["Customers"]}
                                onChange={_ => setSelectedTags({
                                    ...selectedTags,
                                    "Customers": _
                                })} />
                            <Checkbox
                                label="Orders"
                                checked={selectedTags["Orders"]}
                                onChange={_ => setSelectedTags({
                                    ...selectedTags,
                                    "Orders": _
                                })} />
                            <Checkbox
                                label="Tags"
                                checked={selectedTags["Tags"]}
                                onChange={_ => setSelectedTags({
                                    ...selectedTags,
                                    "Tags": _
                                })} />
                            <Checkbox
                                label="Metafields"
                                checked={selectedTags["Metafields"]}
                                onChange={_ => setSelectedTags({
                                    ...selectedTags,
                                    "Metafields": _
                                })} />
                        </Stack>
                        <br />
                    </Layout.Section>
                </Layout>
                <div className='rulesContainer'>
                    <Layout>
                        <Layout.Section oneHalf>
                            {ruleElementsLeft}
                        </Layout.Section>
                        <Layout.Section oneHalf>
                            {ruleElementsRight}
                        </Layout.Section>
                    </Layout>
                </div>
            </Page>
        </div >
    );

    function addRule(ruleType) {

        const definition = getRuleDefinitionByType(ruleType);

        if (definition.legacy) {
            history.push(`/tag-rules/create/${ruleType}`);
        }
        else {
            history.push(`/tag-rules/new/${ruleType}`);
        }
    }

    function requestRule() {
        window.$crisp.push(["do", "chat:open"]);
    }

    function renderRule(item) {
        const { ruleType, title, description, inProgress, tags } = item;

        var heading = <Heading>{title}</Heading>;
        var details = <span>{description}</span>;
        var button = <Button primary onClick={() => addRule(ruleType)}>{"Create Rule"}</Button>
        var tagElements = tags.map(_ => <Tag>{_}</Tag>);

        if (inProgress) {
            heading = <Heading><TextStyle variation="subdued">{title}</TextStyle></Heading>;
            details = <TextStyle variation="subdued"><span>{description}</span></TextStyle>;
            button = <Button onClick={() => requestRule(ruleType)}>Available Soon - Click to Request</Button>
        }

        return (
            <Card sectioned>
                <Stack wrap={false}>
                    <Stack.Item fill>
                        {heading}
                        {<div className="tagsContainer"><Stack>{tagElements}</Stack></div>}
                        {details}
                        <br /><br />
                    </Stack.Item>
                </Stack>
                {button}
            </Card >
        );
    }
}

export default TagRulesNewPage;